/*
PLEASE USE THE SAMPLE BANNER BLOCK PROVIDED BELOW:

{
    bannerImage: '',
    bannerPosition: 1,
    link: '',
},

*/

document.addEventListener('Searchanise.Loaded', function () {
    (function ($) {
        function snizeAddCollectionBanner(snizeBannerUrl, snizeBannerPosition, snizeColUrl) {
            if (location.pathname.includes('/collections')) {
                $(`ul.snize-search-results-content li:nth-child(${snizeBannerPosition})`).before(`
                    <li class="snize-banner snize-custom-banner">
                        ${snizeColUrl ? `<a href=${snizeColUrl} target="_blank">` : ''}
                        <img src=${snizeBannerUrl}></a></li>`
                );
            }
        }

        let snizeBannersData = [
            {
                bannerImage: 'https://cdn.shopify.com/s/files/1/0746/2702/3131/files/Mega_26-Promo-Banner.jpg?v=1791391405',
                bannerPosition: 7,
                link: '',
            },
        ];

        $(document).on('Searchanise.ResultsUpdated', function () {
            if (!$('.snize-custom-banner').length) {
                snizeBannersData.forEach(function (bannerData) {
                    snizeAddCollectionBanner(bannerData.bannerImage, bannerData.bannerPosition, bannerData.link);
                });
            }
        });
    })(window.Searchanise.$);
});
